import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@/shared/api/reauth.api';

export const hvarServiceApi = createApi({
	reducerPath: 'hvar service',
	tagTypes: [],
	baseQuery: baseQueryWithReauth(HVAR_API_URL),
	endpoints: () => ({}),
});
